import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';
import { logVerboseUsage as logVerboseUsageWithMailbox } from 'owa-analytics';
import type { CustomData, DatapointOptions } from 'owa-analytics-types';

export function logVerboseUsage(
    eventName: string,
    customData?: CustomData,
    options?: DatapointOptions
): void {
    logVerboseUsageWithMailbox(eventName, getUserMailboxInfo(), customData, options);
}
